import { useCheckPermission } from './useUserRoles';

/**
 * Hook to check if user has permission to create NEW GDrive folders
 * Uses CREATE_NEW_GDRIVE_FOLDERS permission
 */
export const useCanCreateNewGDriveFolders = () => {
  const { data: hasPermission = false, isLoading } = useCheckPermission('CREATE_NEW_GDRIVE_FOLDERS');
  
  return {
    canCreate: hasPermission,
    isLoading
  };
};
